/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from "react";
import AmericaFlag from "../../../assets/icons/US-FLAG1.svg";
import IndiaFlag from "../../../assets/icons/Indian-Flag.svg";
import {
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  SelectChangeEvent,
} from "@mui/material";
import {
  CountryOption,
  PhoneNumberInputProps,
} from "./new-phone-input-component.types";
import "./new-phone-input-component.scss";

const NewPhoneNumberComponent = ({
  value,
  onChange,
  countryCode,
  onCountryChange,
  placeholder = "Enter your mobile number.",
  maskDigits = 0,
  error,
  helperText,
  onKeyDown,
  disabled = false,
  countries,
  showHelper = false,
  errors,
  onBlur,
}: PhoneNumberInputProps) => {
  // STATES
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);

  const defaultCountries: CountryOption[] = [
    { code: "+1", flag: AmericaFlag, label: "US" },
    { code: "+91", flag: IndiaFlag, label: "India" },
    { code: "+44", flag: "https://flagcdn.com/gb.svg", label: "UK" },
  ];

  countries = countries ?? defaultCountries;

  // Close the menu after selection
  const handleCountryChange = (event: SelectChangeEvent<string>) => {
    onCountryChange(event.target.value);
  };

  // getting masked value from a string;
  const getMaskedValue = (val: string) => {
    if (maskDigits > 0 && val.length > maskDigits) {
      const maskedPart = "X".repeat(maskDigits);
      const visiblePart = val.slice(maskDigits);
      return maskedPart + visiblePart;
    }
    return val;
  };

  // digits input allowed only;
  const handleChange = (input: string) => {
    // removing non-digit characters and limit to 10 digits
    const digitsOnly = input.replace(/\D/g, "").slice(0, 10);
    onChange(digitsOnly);
  };
let finalHelperText = "";
let isWarning = false;

if (showHelper && typeof helperText === "string" && helperText) {
  finalHelperText = helperText;
  isWarning = true;
}

  // useEffect(() => {
  //   if (!hasErrors && value.length === 0) {
  //     setTouched(false);
  //     setFocused(false);
  //   }
  // }, [hasErrors, value]);

  return (
    <TextField
      disabled={disabled}
      name="phoneNumber"
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      fullWidth
      variant="outlined"
      onFocus={() => setFocused(true)}
      onBlur={(e) => {
        setFocused(false);
        setTouched(true);
        if (onBlur) onBlur(e);
      }}
      error={error}
      helperText={finalHelperText}
      autoComplete="new-password"
      inputProps={{
        autoComplete: "new-password",
        inputMode: "numeric",
        form: { autoComplete: "new-password" },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "38px",
          paddingRight: "8px",
          fontSize: "15px",
          width: {
            lg: "102%",
          },
          "&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D9D9D9 !important",
          },
        },
        "& .MuiOutlinedInput-input": {
          padding: "10px 6px",
          "&::placeholder": {
            color: "#a2a2a2",
            opacity: 1,
          },
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "inherit !important",
        },
        fontSize: "24px",
        "& .MuiFormHelperText-root": {
          ...(isWarning && {
            mt: 0.1,
            color: "#d32f2f !important",
          }),
          ...(error && {
            color: "#d32f2f !important",
          }),
        },
      }}
      InputProps={{
        autoComplete: "new-password",
        startAdornment: (
          <InputAdornment position="start" sx={{ p: 0, m: 0 }}>
            <Select
              value={countryCode}
              onChange={handleCountryChange}
              variant="standard"
              disableUnderline
              aria-label="Select country code"
              MenuProps={{
                disableScrollLock: true,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  sx: {
                    zIndex: 1400,
                    borderRadius: 1,
                    marginTop: "4px",
                    pointerEvents: "auto",
                  },
                },
              }}
              sx={{
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  p: 0,
                  pr: "8px",
                  cursor: "pointer",
                },
                minHeight: "38px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {countries.map((c: CountryOption) => (
                <MenuItem
                  key={c.code}
                  value={c.code}
                  aria-label={`${c.label} ${c.code}`}
                >
                  <img
                    src={c.flag}
                    alt={`${c.label} flag`}
                    style={{
                      width: "24px",
                      height: "18px",
                      objectFit: "cover",
                      marginRight: "6px",
                      borderRadius: "1px",
                    }}
                  />
                  {c.code}
                </MenuItem>
              ))}
            </Select>
          </InputAdornment>
        ),
        sx: {
          borderRadius: "12px",
        },
      }}
    />
  );
};

export default NewPhoneNumberComponent;
